import { createContext, useContext } from "react";

export interface RequiredToken {
  address: string;
  chainId: number;
  symbol: string;
  reason?: string;
}

/**
 * Context for providing requiredTokens to wallet selector fields.
 * Avoids threading requiredTokens through FormField → FormFieldConnector props.
 */
export const RequiredTokensContext = createContext<RequiredToken[] | undefined>(undefined);

export function useRequiredTokens(): RequiredToken[] | undefined {
  return useContext(RequiredTokensContext);
}
